
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition du community management: Éclairage complet pour entreprise et particulier",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition community-management, son importance, sa fonction et comment il façonne votre présence en ligne. Informez-vous davantage pour optimiser votre marque.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition du community management: Éclairage complet pour entreprise et particulier",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition community-management, son importance, sa fonction et comment il façonne votre présence en ligne. Informez-vous davantage pour optimiser votre marque.",
        },
      ],
    };
  },
};
